// import getItemRemote from "@/composables/remote/getItem";
import getItem from "@/composables/getItem";


// check History
const checkEnrolleeHistory = async (enrollee, encounterDate) => {
    // start
    let endPoint = null;
    let callFunction = null;
    let enrollee_id = enrollee?.id;
    let enrollee_name = enrollee?.name;
    let enrollee_number = enrollee?.enrollee_number;
    let encounter_date = encounterDate;
    let provider_id = enrollee?.provider_id;

    // check and set
    // if (payer?.remote?.setting_enrollee_api) {
    //     // set remote endpoint
    //     endPoint = payer?.remote?.setting_enrollee_history_api;
    //     // load call function
    //     callFunction = getItemRemote;
    // } else {
    //     // default endpoint
    //     endPoint = "encounter/single/history";
    //     // default call function
    //     callFunction = getItem;
    // }

    // check on oneprovider Server only!
    //default endpoint
    endPoint = "encounter/single/history";
    // default call function
    callFunction = getItem;

    // val
    let val = `provider_id=${provider_id}&enrollee_name=${enrollee_name}&enrollee_number=${enrollee_number}&encounter_date=${encounter_date}`;

    // all
    const { res } = await callFunction(endPoint, `${enrollee_id}?${val}`);

    if (res.value) {
        return { status: true, val: res.value.data }
    } else {
        return { status: false, val: null };
    }
};



export {
    checkEnrolleeHistory,
}